import { gql } from "@urql/core";

export const RECEIVING_QUERY = gql`
  query Receivings(
    $filter: JSONObject
    $sorting: [SortInput!]
    $paging: PaginationInput
  ) {
    receivings(query: { filter: $filter, sorting: $sorting, paging: $paging }) {
      nodes {
        id
        receivingNo
        poId
        poNo
        deliveryDate
        expectedDeliveryDate
        vendorInfo {
          vendorId
          companyName
          contactPerson
          email
          phone
          address
          tin
        }
        items {
          id
          name
          description
          orderedQty
          receivedQty
          acceptedQty
          rejectedQty
          unit
          unitPrice
          remarks
          sourceOrderItemId
          tags
        }
        status
        attachments {
          fileId
          originalName
          mimeType
          size
          category
        }
        notes
        deliveryNotes
        qualityCheckBy
        qualityCheckDate
        qualityCheckResult
        totalReceivedValue
        totalAcceptedValue
        tags
        submittedBy
        approvedBy
        approvedAt
        flowCaseId
        flowCaseNumber
        approvalType
        steps {
          order
          roleSlug
          stepName
          approvedBy
          approvedOn
          remarks
          stepStatus
        }
        externalWorkflow
        approvalData
        createdAt
        updatedAt
        createdBy
        updatedBy
        receivingTemplateId
        acceptanceTemplateId

      }
      pagination {
        total
        current
        pageSize
        totalPages
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const RECEIVING_BY_ID_QUERY = gql`
  query ReceivingById($id: String!) {
    receiving(id: $id) {
      id
      receivingNo
      poId
      poNo
      deliveryDate
      expectedDeliveryDate
      vendorInfo {
        vendorId
        companyName
        contactPerson
        email
        phone
        address
        tin
      }
      items {
        id
        name
        description
        orderedQty
        receivedQty
        acceptedQty
        rejectedQty
        unit
        unitPrice
        remarks
        sourceOrderItemId
        tags
      }
      status
      attachments {
        fileId
        originalName
        mimeType
        size
        category
      }
      notes
      deliveryNotes
      receivedBy
      inspectionDate
      acceptedBy
      acceptedDate
      inspectionNotes
      qualityCheckBy
      qualityCheckDate
      qualityCheckResult
      totalReceivedValue
      totalAcceptedValue
      tags
      submittedBy
      approvedBy
      approvedAt
      flowCaseId
        flowCaseNumber
      approvalType
      steps {
        order
        roleSlug
        stepName
        approvedBy
        approvedOn
        remarks
        stepStatus
      }
      externalWorkflow
      acceptanceExternalWorkflow
      acceptanceApprovalType
      approvalData
      createdAt
      updatedAt
      createdBy
      updatedBy
      receivingTemplateId
      acceptanceTemplateId

    }
  }
`;

export const RECEIVINGS_BY_PO_QUERY = gql`
  query ReceivingsByPO($poId: String!) {
    receivingsByPO(poId: $poId) {
      id
      receivingNo
      status
      deliveryDate
      totalReceivedValue
      totalAcceptedValue
      items {
        id
        name
        receivedQty
        acceptedQty
        rejectedQty
      }
    }
  }
`;

export const RECEIVINGS_BY_STATUS_QUERY = gql`
  query ReceivingsByStatus($status: String!) {
    receivingsByStatus(status: $status) {
      id
      receivingNo
      poNo
      vendorInfo {
        companyName
      }
      status
      deliveryDate
      createdAt
    }
  }
`;

export const CREATE_RECEIVING_MUTATION = gql`
  mutation CreateReceiving($input: CreateReceivingInput!) {
    createReceiving(input: $input) {
      id
      receivingNo
      status
      approvalType
      steps {
        order
        roleSlug
        stepName
      }
      externalWorkflow
      approvalData
      flowCaseId
        flowCaseNumber
      submittedBy
    }
  }
`;

export const UPDATE_RECEIVING_MUTATION = gql`
  mutation UpdateReceiving($id: String!, $input: UpdateReceivingInput!) {
    updateReceiving(id: $id, input: $input) {
      id
      receivingNo
      status
      approvalType
      steps {
        order
        roleSlug
        stepName
      }
      externalWorkflow
      approvalData
      flowCaseId
        flowCaseNumber
      submittedBy
    }
  }
`;

export const DELETE_RECEIVING_MUTATION = gql`
  mutation DeleteReceiving($id: String!) {
    deleteReceiving(id: $id) {
      id
    }
  }
`;

export const SUBMIT_RECEIVING_MUTATION = gql`
  mutation SubmitReceiving($input: SubmitReceivingInput!) {
    submitReceiving(input: $input) {
      id
      status
      approvalType
      steps {
        order
        roleSlug
        stepName
      }
      externalWorkflow
      approvalData
      flowCaseId
        flowCaseNumber
      submittedBy
    }
  }
`;

export const PERFORM_QUALITY_CHECK_MUTATION = gql`
  mutation PerformQualityCheck($input: QualityCheckInput!) {
    performQualityCheck(input: $input) {
      id
      status
      qualityCheckBy
      qualityCheckDate
      qualityCheckResult
    }
  }
`;

export const APPROVE_RECEIVING_MUTATION = gql`
  mutation ApproveReceiving($input: ReceivingApprovalInput!) {
    approveReceiving(input: $input) {
      id
      status
      approvedBy
      approvedAt
      steps {
        order
        stepStatus
        approvedBy
        approvedOn
        remarks
      }
    }
  }
`;

export const REJECT_RECEIVING_MUTATION = gql`
  mutation RejectReceiving($input: ReceivingApprovalInput!) {
    rejectReceiving(input: $input) {
      id
      status
      steps {
        order
        stepStatus
        remarks
      }
    }
  }
`;

export const ATTACH_FILES_TO_RECEIVING_MUTATION = gql`
  mutation AttachFilesToReceiving($input: AttachFilesToReceivingInput!) {
    attachFilesToReceiving(input: $input) {
      id
      attachments {
        fileId
        originalName
        mimeType
        size
        category
      }
    }
  }
`;

export const REMOVE_FILE_FROM_RECEIVING_MUTATION = gql`
  mutation RemoveFileFromReceiving($input: RemoveFileFromReceivingInput!) {
    removeFileFromReceiving(input: $input) {
      id
      attachments {
        fileId
      }
    }
  }
`;